import React from "react";

/**
 * Diamond risk badge — a rotated square swatch + a horizontal label below it.
 * Clear at small sizes and in PDF exports, unlike rotated-text diamonds.
 */
const TONES = {
  high: {
    color: "#F08080",
    label: "Hoog risico",
    glow: "rgba(240, 128, 128, 0.35)",
  },
  medium: {
    color: "#F4C430",
    label: "Midden risico",
    glow: "rgba(244, 196, 48, 0.35)",
  },
  low: {
    color: "#9FE2BF",
    label: "Laag risico",
    glow: "rgba(159, 226, 191, 0.35)",
  },
  compliant: {
    color: "#9FE2BF",
    label: "Compliant",
    glow: "rgba(159, 226, 191, 0.45)",
  },
};

const RiskDiamond = ({ level = "medium", testid }) => {
  const tone = TONES[level] || TONES.medium;
  return (
    <div
      data-testid={testid}
      data-risk={level}
      className="flex flex-col items-center"
    >
      <span
        aria-hidden
        style={{
          width: 22,
          height: 22,
          transform: "rotate(45deg)",
          border: `1px solid ${tone.color}`,
          background: `${tone.color}22`,
          boxShadow: `0 0 14px -2px ${tone.glow}`,
        }}
      />
      <span
        className="mt-3 text-[10px] tracking-[0.22em] uppercase whitespace-nowrap"
        style={{ color: tone.color, fontWeight: 500 }}
      >
        {tone.label}
      </span>
    </div>
  );
};

export default RiskDiamond;
